/** Class 12 — same 34×A–D shape as grade 10; replace `RAW` when you have final copy. */
import { RAW as BASE } from "./10.js";

function cloneRaw(base) {
  if (typeof structuredClone === "function") return structuredClone(base);
  return JSON.parse(JSON.stringify(base));
}

export const RAW = cloneRaw(BASE);
